import React from "react";

const Resume = ({ data }) => {
  if (data) {
    var skillmessage = data.skillmessage;
    var education = data.education.map(function (education) {
      return (
        <div key={education.school}>
          <h3>{education.school}</h3>
          <p className="info">
            {education.degree} <span>&bull;</span>
            <em className="date">{education.graduated}</em>
          </p>
          <p>{education.description}</p>
        </div>
      );
    });
    var work = data.work.map(function (work) {
      return (
        <div className="company" key={work.company}>
        <h3>{work.company}</h3>
        {work.data ? (
          work.data.map((role, index) => (
            <p className="info" key={index}>
              {role.position}
              <span>&bull;</span> <em className="date">{role.years}</em>
            </p>
          ))
        ) : (
          <p className="info">
            {work.title}
            <span>&bull;</span> <em className="date">{work.years}</em>
          </p>
        )}
          <p>{work.description}</p>
        </div>
      );
    });
    var skills = Object.entries(data.skills).map(function ([category, skills]) {
      return (
        <div key={category}>
          <strong>{category}:</strong> {skills.join(", ")}
        </div>
      );
    });
  }

  return (
    <section id="resume">
 <div className="row education">
        <div className="three columns header-col">
          <h1>
            <div>Work</div>
          </h1>
        </div>

        <div className="nine columns main-col">
          <div className="row item">
            <div className="twelve columns">{work}</div>
          </div>
        </div>
        </div>
      <div className="row education">
        <div className="three columns header-col">
          <h1>
            <div>Education & Certifications</div>
          </h1>
        </div>

        <div className="nine columns main-col">
          <div className="row item">
            <div className="twelve columns">{education}</div>
          </div>
        </div>
      </div>

      
      <div className="row skill">
        <div className="three columns header-col">
          <h1>
            <div>Skills</div>
          </h1>
        </div>

        <div className="nine columns main-col">
          <p>{skillmessage}</p>

          <div className="bars">
            <ul className="skills">{skills}</ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Resume;
